import { useState, useMemo } from 'react';

import { RealEstateDict } from '@monoimin/intl';

import { Input } from '@monoimin/molecules/inputs/RealEstateInput';

import { SelectList, SelectListProps } from './SelectList';

import type { SelectItem } from '../types';

export type SearchListProps<T extends SelectItem> = Pick<
  SelectListProps<T>,
  'data' | 'value' | 'onChange'
> & { placeholder?: string; realEstateDict: RealEstateDict };

export const SearchList = <T extends SelectItem>({
  data,
  value,
  onChange,
  placeholder,
  realEstateDict,
}: SearchListProps<T>) => {
  const [search, setSearch] = useState('');

  const selectData = useMemo(() => {
    if (search) {
      return data.filter((item) => {
        if (!item.title) {
          return false;
        }

        return item.title.toLowerCase().includes(search.toLowerCase());
      });
    }

    return data;
  }, [data, search]);

  return (
    <div className='flex flex-col'>
      <Input
        value={search}
        onChange={(event) => {
          setSearch(event.target.value);
        }}
        className='mx-5 mb-5'
        placeholder={placeholder}
        size='large'
      />
      {search && !selectData.length ? (
        <div className='px-5 py-2 text-center col-span-full body'>
          <p>{realEstateDict.noSearchResults}</p>
        </div>
      ) : null}
      <SelectList data={selectData} value={value} onChange={onChange} />
    </div>
  );
};
